import React, { useState } from 'react';
import { Rate, Input, Button } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import chatService from '../../services/chatService';

const { TextArea } = Input;

const FeedbackForm = ({ sessionId, customerName, onComplete }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) return;
    setSubmitting(true);
    try {
      await chatService.submitFeedback(rating, comment, sessionId, customerName);
    } catch {
      // Hata olsa bile akisi ilerlet — puan gidemese de kullaniciyi bekletmeyiz
    } finally {
      setSubmitting(false);
      // true = puan gonderildi -> tesekkur ekrani gosterilir.
      // Toast KULLANILMIYOR: antd'nin statik message'i widget'in
      // ConfigProvider'i disinda render ediliyor ve embed iframe'inde kirpiliyor.
      onComplete(true);
    }
  };

  const handleSkip = () => {
    // Atlayan kullaniciya tesekkur ekrani gosterilmez, widget kapanir
    onComplete(false);
  };

  return (
    <div className="chat-form-container">
      <div className="chat-form-header">
        <div style={{ fontSize: 36, marginBottom: 8 }}>
          <SmileOutlined style={{ color: 'var(--chat-primary)' }} />
        </div>
        <h3>Deneyiminizi Puanlayın</h3>
        <p>Gorüşleriniz bizim için değerli</p>
      </div>

      <div style={{ textAlign: 'center', margin: '16px 0 24px' }}>
        <Rate
          value={rating}
          onChange={setRating}
          className="chat-feedback-rate"
        />
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontWeight: 600, fontSize: 13, color: 'var(--chat-text-primary)', display: 'block', marginBottom: 8 }}>
          Yorumunuz (opsiyonel)
        </label>
        <TextArea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Deneyiminiz hakkında bir şeyler yazın..."
          maxLength={500}
          showCount
          style={{
            borderRadius: 12,
            background: 'var(--chat-surface-secondary)',
            border: '1px solid var(--chat-border)',
          }}
        />
      </div>

      <Button
        type="primary"
        size="large"
        block
        className="chat-form-submit"
        onClick={handleSubmit}
        loading={submitting}
        disabled={rating === 0}
      >
        Gönder
      </Button>

      <Button
        size="large"
        block
        className="chat-form-skip"
        onClick={handleSkip}
        style={{ marginTop: 12 }}
      >
        Atla
      </Button>
    </div>
  );
};

export default FeedbackForm;
